import React from "react"
import Img from "gatsby-image"
import HeaderStyles from './header.module.scss'

const HeaderSection = ( props ) => {

return (
  <section className={[HeaderStyles.headerWrapper, props.logo ? null : HeaderStyles.headerWrapperSmall].join(' ')}>
      {props.bg ? <Img loading="eager" fadeIn={false} className={HeaderStyles.bg} fluid={props.bg} /> : null }
      {/* props.logo ? <Img className={HeaderStyles.logo} fluid={props.logo} /> : null */ }
  </section>
)}

export default HeaderSection
